export default __webpack_public_path__ + "static/media/instagram.25062ab2.svg";